// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hmV_","field":"styles_field__u4Q3l","fieldCol":"styles_fieldCol__2OxD4","diffCol":"styles_diffCol__3Ibu2","diff":"styles_diff__3_YhJ"};